import React from 'react'
import { CLASS_PREFIX } from 'src/constants'

import './gradient_link.scss'

const cls = `${CLASS_PREFIX}gradient-link`

type Props = {
  href: string;
} & Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'>

export const GradientLink: React.FC<Props> = ({ href, children, className, ...rest }) => {
  return (
    <a
      className={className ? `${cls} ${className}` : cls}
      href={href}
      {...rest}
    >
      {children}
    </a>
  )
}

export default GradientLink
